import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { Motivation, MotivationDescriptor, MotivationTooltips } from '@app/enums/motivation';
import { CountryDescriptor, CountryFlags } from '@app/enums/country';
import { AppDatePipe } from '@app/pipes/app-date.pipe';
import { IncidentDetailsPageStore } from '../incident-details-page.store';

@Component({
  standalone: true,
  selector: 'app-incident-info',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatCardModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    AppDatePipe,
  ],
  templateUrl: './incident-info.component.html',
  styleUrl: './incident-info.component.scss',
})
export class IncidentInfoComponent {
  @Input({ required: true })
  public formGroup!: FormGroup;

  public CountryDescriptor: Record<string, string> = CountryDescriptor;
  public MotivationDescriptor: Record<string, string> = MotivationDescriptor;
  public MotivationTooltips: Record<string, string> = MotivationTooltips;
  public motivationKeys = Object.keys(Motivation);
  public CountryFlags: Record<string, string> = CountryFlags;

  public get attackPeriodGroup(): FormGroup {
    return this.formGroup.get('incidentAttackPeriod') as FormGroup;
  }

  constructor(protected readonly incidentsPageStore: IncidentDetailsPageStore) {}
}
